<script>
import CommentModel from '@/models/comments/commentModel'

import CommentBase from './comment-base.vue'
import usaPayBreakdownSnapshot from './payBreakdownTemplates/usaPayBreakdownSnapshot.vue'
import defaultPayBreakdownSnapshot from './payBreakdownTemplates/defaultPayBreakdownSnapshot.vue'

export default {
  components: { CommentBase },

  props: {
    comment: {
      type: CommentModel,
      required: true,
    },
  },
  computed: {
    payBreakdownComponent() {
      const type = JSON.parse(this.comment.commentText).type

      switch (type) {
        case 'Detroit.ViewModels.Finance.Payslips.Calculators.USPayslipCalculatorResultBooking, Detroit.ViewModels':
          return this.payBreakdownCommentFactory(usaPayBreakdownSnapshot)
        default:
          return this.payBreakdownCommentFactory(defaultPayBreakdownSnapshot)
      }
    },
  },

  methods: {
    payBreakdownCommentFactory(component) {
      return {
        component,
        props: {
          comment: this.comment,
        },
        events: {},
      }
    },
  },
}
</script>

<template>
  <CommentBase
    :added-by="comment.addedBy"
    :subtitle="comment.getDateCreatedTimestamp()"
    :active="isSelected"
  >
    <template>
      <p class="font-weight-medium">Pay Breakdown</p>
      <component
        :is="payBreakdownComponent.component"
        v-bind="payBreakdownComponent.props"
      />
    </template>
  </CommentBase>
</template>
